let analyticsLoaded = false

let clarityInitialized = false

export const initClarity = () => {
  if (clarityInitialized) return

  const clarityId = process.env.REACT_APP_CLARITY_ID
  if (!clarityId) {
    console.warn('Clarity Project ID not set')
    return
  }

  console.log('Clarity initializing...');
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        ;(c[a].q = c[a].q || []).push(arguments)
      }
    t = l.createElement(r)
    t.async = 1
    t.src = `https://www.clarity.ms/tag/${i}`
    t.crossOrigin = "anonymous"
    y = l.getElementsByTagName(r)[0]
    y.parentNode.insertBefore(t, y)
  })(window, document, 'clarity', 'script', clarityId)

  clarityInitialized = true
}


// export const FinkTrack = (eventName, properties = {}) => {
//   if (typeof window.clarity === 'function') {
//     window.clarity('track', eventName, properties)
//     console.log(`[Clarity] Track: ${eventName}`, properties)
//   }
// }

export function FinkTrack(eventName, properties = {}) {
  if (typeof window.clarity === 'function') {
    try {
      window.clarity('event', eventName, properties)
      console.log(`[Clarity] Track: ${eventName}`, properties)
    } catch (e) {
      console.warn('Clarity event tracking failed:', e)
    }
  } else if (Array.isArray(window.clarity?.q)) {
    window.clarity.q.push(['event', eventName, properties])
  } else {
    console.warn('Clarity not initialized yet')
  }
}

export const FinkSet = (key, value) => {
  if (typeof window.clarity === 'function') {
    window.clarity('set', key, value)
    console.log(`[Clarity] Set: ${key} = ${value}`)
  }
}
